import { createApp } from "vue";
import SavedVehiclesPage from "./savedVehiclesPage.vue";
import OrionSavedVehiclesPage from "./orionSavedVehiclesPage.vue";
import { DealerFeaturesService } from "@/services/dealerFeaturesService";
import { getDealerId, getOrionQueryOverride } from "@/utils/dealerUtils";
// Resolve the Orion toggle before mounting so each page component stays free of branching logic.
// getOrionQueryOverride (?useOrionPage=on/off) forces Orion on/off for preview/QA; otherwise (null)
// getIsOrionEnabled decides and fails closed to false, so any backend error keeps the legacy experience.
const dealerId = String(getDealerId());
const dealerFeaturesService = new DealerFeaturesService();
const isOrion = getOrionQueryOverride() ?? (await dealerFeaturesService.getIsOrionEnabled(dealerId));
const page = isOrion ? OrionSavedVehiclesPage : SavedVehiclesPage;
createApp(page).mount("#vehicle-carousel-block");
